import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var Board = require("components/utility/Board");
var DropDownOptions = require("components/utility/DropDownOptions");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var Spinner = require("components/utility/Spinner");
var CurrentUser = require("lib/account/CurrentUser");
var AssignTaskModal = require("components/writing/tasks/AssignTaskModal");
var AssignExerciseDetailsModal = require("components/writing/activities/AssignExerciseDetailsModal.js");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var PicksPage = require("components/reading/picks/PicksPage");

var Skillsets = require("lib/academic/Skillsets");
var TextTypes = require("lib/academic/TextTypes");
var Features = require("lib/account/Features");
var ResponseModal = require("components/writing/responses/ResponseModal");
var Formats = require("lib/academic/Formats");
var GradeLevel = require("lib/academic/GradeLevel.js");
var HelpSectionLink = require("components/utility/HelpSectionLink");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var WritingActions = require('lib/actions/WritingActions');
var WritingSelectors = require('lib/selectors/WritingSelectors');
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var ActionUtility = require("lib/shared/ActionUtility");
var Modal = require('components/utility/AltModal');

var ActivitiesPageRouting = require("lib/routing/ActivitiesPageRouting");

require("writing/activities/exercise_page.scss");

@connect(
  (state, props) => ({
    user: CurrentUser.get(),
    activities: WritingSelectors.getMostRecentActivities({ state, withAssigned: true }) || [],
    studentLists: RosterSelectors.studentLists({ state }),
    isLoadingLogs: ReadingSelectors.isLoadingLogs({ state })
  }),
  (dispatch, props) => ({
    fetchActivities: function (attr) {
      const { filters, conditions, embeds, page, cache } = attr;
      return dispatch(WritingActions.fetchActivities({
        filters, conditions, embeds, page, cache
      }))
    },
    clearActivities: () => dispatch(WritingActions.clearActivities()),

    populateData: () => {
      // TODO: standardize FE requests
      var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick", 'exercise'] } }
      var embeds = ['task.task_items']
      if ($wr.isLargeRequest(props.userIDs)) {
        var actionFunction = WritingActions.fetchTasks
        return new Promise(function (resolve, reject) {
          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, { embeds }, (results) => {
            resolve(results)
          })
        }).catch(() => console.log("Tasks failed to load"))
      } else {
        return dispatch(WritingActions.fetchTasks({ embeds, conditions }))
      }
    },
    fetchTasks: () => {
      dispatch(ActionUtility.clearLoadingRecords("tasks"))
      var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick", 'exercise'] } }
      var embeds = ['task.task_items']
      if ($wr.isLargeRequest(props.userIDs)) {
        var actionFunction = WritingActions.fetchTasks
        return new Promise(function (resolve, reject) {
          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, { embeds }, (results) => {
            resolve(results)
          })
        }).catch(() => console.log("Tasks failed to load"))
      } else {
        return dispatch(WritingActions.fetchTasks({ embeds, conditions }))
      }
    }
  })
)

@providePopulateData({ waitForLoad: true })
class ExercisePage extends React.Component {
  constructor(props) {
    super();
    autobind(this);
    var selGradeLevel = $wr.getURLParameterByName("grade_level") || props.user.grade_level;
    this.assignTaskModal = React.createRef();
    this.AssignExerciseDetailsModal = React.createRef();

    this.state = {
      stateVersion: 0,

      // Vars for lazyloading activities
      page: null, loading: false, doneLoading: false,

      // Allows us to show a completed response on this page
      previewResponseID: null,

      // Allow teachers to create tasks
      activityToAssignID: null,

      // Activity title
      selectedActivityTitle: "",

      // Filter options
      selectedSkillset: $wr.getURLParameterByName("skillset"),
      selectedTextVariety: TextTypes.Varieties.BOTH,
      selectedGrade: selGradeLevel,
      selectedFormat: null,
      selectedUserIDs: [],

      view: EXERCISE_VIEW,
    };
  }

  assignActivity(activity) {
    this.setState({
      activityToAssignID: activity.id,
      selectedActivityTitle: activity.format_summary.title
    }, () => {
      this.assignTaskModal.current.show()
    });
  }

  buildOnSkillsetSelectF(skillset) {
    return function (e) {
      $wr.nope(e)
      this.setState({ selectedSkillset: skillset }, function () {
        this.resetActivities();
      }.bind(this));
      Mycroft.newEvent({ category: "Activities Board", action: "select-skillset", label: skillset });
    }.bind(this);
  }

  buildOnTextVarietySelectF(textVariety) {
    return function (e) {
      $wr.nope(e)
      this.setState({ selectedTextVariety: textVariety }, function () {
        this.resetActivities();
      }.bind(this));
      Mycroft.newEvent({ category: "Activities Board", action: "select-text-variety", label: textVariety });
    }.bind(this);
  }

  buildOnFormatSelectF(format) {
    return function () {
      this.setState({ selectedFormat: format }, function () {
        this.resetActivities();
      }.bind(this));
      Mycroft.newEvent({ category: "Activities Board", action: "select-format", label: format });
    }.bind(this);
  }

  buildOnGradeSelectF(grade) {
    return function () {
      this.setState({ selectedGrade: grade }, function () {
        this.resetActivities();
      }.bind(this));
      Mycroft.newEvent({ category: "Activities Board", action: "select-grade", label: grade });
    }.bind(this);
  }

  renderSkillsetSelector() {
    var readingOptions = DropDownOptions.Button.Skillsets({
      buildOptionF: this.buildOnSkillsetSelectF, ogReadingOnly: true
    });

    var writingOptions = DropDownOptions.Button.Skillsets({
      buildOptionF: this.buildOnSkillsetSelectF, writingOnly: true
    });

    var skillset = this.state.selectedSkillset;
    if (skillset == undefined) {
      var skillsetText = "All skill sets";
    } else {
      var skillsetText = Skillsets.getName(skillset);
    }

    return (
      <ButtonDropdown text={skillsetText} dropdownDisplay="link"
        className="skillsetControl nested">

        <ButtonDropdownOption onClick={this.buildOnSkillsetSelectF(null)}
          text="All skill sets" className="topLevel" />

        <li className="dropdown-header">Reading</li>
        { readingOptions}

        <li className="dropdown-header">Writing</li>
        { writingOptions}
      </ButtonDropdown>
    );
  }

  renderFilterControls() {

    var formatOptions = DropDownOptions.Button.Formats({
      buildOptionF: this.buildOnFormatSelectF, allOption: true
    });
    var format = this.state.selectedFormat
    if (format == undefined) {
      var formatText = "All formats";
    } else {
      var formatText = Formats.getName(format);
    }

    var textVarietyOptions = DropDownOptions.Button.TextVarieties({
      buildOptionF: this.buildOnTextVarietySelectF
    });
    var textVarietyText = TextTypes.Varieties.getName(this.state.selectedTextVariety);
    var buttonDropdownFormatFilter = (
      <ButtonDropdown text={formatText} dropdownDisplay="link"
        className="formatControl">
        { formatOptions}
      </ButtonDropdown>
    );

    var grade = this.state.selectedGrade
    if (grade == undefined) {
      var gradeText = "All grades";
    } else {
      var gradeText = GradeLevel.getName(grade);
    }
    var gradeOptions = DropDownOptions.Button.Grades({
      buildOptionF: this.buildOnGradeSelectF, allOption: true,
      currentGradeLevel: this.props.user.grade_level
    });

    return (
      <div className="filterControls">
        <ButtonDropdown text={gradeText} dropdownDisplay="link"
          className="gradeControl">
          {gradeOptions}
        </ButtonDropdown>
        { this.renderSkillsetSelector()}
        { buttonDropdownFormatFilter}
        <ButtonDropdown text={textVarietyText} dropdownDisplay="link"
          className="textVarietyControl">
          {textVarietyOptions}
        </ButtonDropdown>
      </div>
    );
  }

  renderAssignTaskModal() {
    var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";
    return (
      <Modal headerText={modalHeader} ref={this.assignTaskModal} modalOrder={2}>
        <AssignTaskModal key={this.state.activityToAssignID}
          taskSubjectType="exercise"
          taskSubjectID={this.state.activityToAssignID}
          selectedActivityTitle={this.state.selectedActivityTitle}
          renderAdditionalModal={true}
          onAssign={this.hideAssignModal}
        />
      </Modal>
    )
  }

  hideAssignModal(selectedUserIDs, showNextModal) {
    showNextModal = showNextModal === null ? false : showNextModal;

    this.setState({ selectedUserIDs: selectedUserIDs })

    this.assignTaskModal.current.hide();
    if (showNextModal) {
      this.AssignExerciseDetailsModal.current.show();
    }
  }

  renderAssignExerciseDetailsModal() {
    var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";
    return (
      <Modal ref={this.AssignExerciseDetailsModal} headerText={modalHeader} modalOrder={3}>
        <AssignExerciseDetailsModal
          selectedUserIDs={this.state.selectedUserIDs}
          taskSubjectType="Exercise"
          taskSubjectID={this.state.activityToAssignID}
          selectedActivityTitle={this.state.selectedActivityTitle}
          onAssign={this.hideAssignExerciseDetailsModal} />
      </Modal>
    )
  }

  hideAssignExerciseDetailsModal() {
    this.AssignExerciseDetailsModal.current.hide();
    this.props.fetchTasks()
  }

  render() {

    if (this.state.previewResponseID) {
      var previewModal = (
        <ResponseModal ref="previewResponseModal"
          key={this.state.previewResponseID} adminPreview={true}
          responseID={this.state.previewResponseID} />
      );
    }

    if (this.state.activityToAssignID) {
      var assignTaskModal = this.renderAssignTaskModal()
    }

    var activities = this.props.activities || [];

    if (this.state.selectedSkillset == undefined) {
      var skillsetText = "All skill sets";
    } else {
      var skillsetText = Skillsets.getName(this.state.selectedSkillset);
    }

    if (this.state.doneLoading) {
      var doneLoadingNotice = (
        <div className="doneLoadingNotice">
          That's it for now, but we are always adding new exercises.
          Have exercise ideas of your own? Email ideas or worksheets
					to <a href="mailto:exercises@whooosreading.org">exercises@whooosreading.org</a> and
					we will create them! (Note: We cannot create exercises
					that go with a specific book).
        </div>
      )
    }

    var activeViewContent = (
      <div>
        <div className="clearfix">
          {this.renderFilterControls()}
          <p>
            <HelpSectionLink featureName="allowing pop-ups to view/print" linkSuffix="115002455792" iconOnly={false} />
          </p>
        </div>

        <Board type={Board.TEACHER_ACTIVITIES} key={this.state.stateVersion}
          items={activities} onItemAssign={this.assignActivity}
          loading={this.state.loading} onScrollToBottom={this.fetchActivities} />

        { doneLoadingNotice}
      </div>
    );

    return (
      <div className="container exercisePage">
        { activeViewContent}
        { previewModal}
        { assignTaskModal}
        { this.renderAssignExerciseDetailsModal()}
      </div>
    )
  }

  resetActivities() {
    this.props.clearActivities();
    this.setState({
      doneLoading: false, page: null,
      stateVersion: (this.state.stateVersion + 1)
    }, function () {
      this.fetchActivities();
    }.bind(this));
  }

  fetchActivities() {
    if (!this.state.doneLoading) {
      this.props
        .fetchActivities({
          page: this.state.page + 1 || null,
          embeds: ["activity.format_summary"],
          filters: {
            text_varieties: this.state.selectedTextVariety,
            ...(this.state.selectedGrade != null ? { grade_levels: this.state.selectedGrade } : null),
            ...(this.state.selectedFormat ? { formats: this.state.selectedFormat } : null),
            ...(this.state.selectedSkillset ? { skillsets: this.state.selectedSkillset } : null),
          },
        })
        .then(action => {
          const doneLoading = action.noMorePages || false;
          const page = action.pagination.page;

          this.setState({ page, doneLoading, loading: false })
        });
      this.setState({ loading: true });
    }
  }

  componentDidMount() {
    this.fetchActivities();
  }
};

ExercisePage.EXERCISES_VIEW = "all-exercises";
ExercisePage.ASSIGNED_TASKS_VIEW = "assigned-tasks";
ExercisePage.COMPLETED_TASKS_VIEW = "completed-tasks";

var EXERCISE_VIEW = "exercise";
var TEACHER_PICKS_VIEW = "teacher-picks";

module.exports = ExercisePage;



// WEBPACK FOOTER //
// ./modules/components/writing/activities/ExercisePage.js